import { render, staticRenderFns } from "./ProductSalePieChart.vue?vue&type=template&id=cb4c1100&scoped=true&"
import script from "./ProductSalePieChart.vue?vue&type=script&lang=js&"
export * from "./ProductSalePieChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4c1100",
  null
  
)

export default component.exports